import { useSnackbar } from 'notistack';
import { Dispatch, useEffect, useRef } from 'react';
import { deleteSiteProcess } from '../../../../apicalls/process';
import { checkResData } from '../../../../utils/common';

export type Props = {
  isOpen: boolean;
  setIsOpen: Dispatch<boolean>;
  afterSubmit: () => void;
  siteProcessId: number;
};

export const useHooks = (props: Props) => {
  // snackbar
  const { enqueueSnackbar } = useSnackbar();

  const { isOpen, setIsOpen, afterSubmit, siteProcessId } = props;

  // 送信可能フラグ 多重送信対策
  const isSubmitable = useRef(false);

  const submit = () => {
    if (!isSubmitable.current) return;

    isSubmitable.current = false;

    deleteSiteProcess(siteProcessId).then((resData: any) => {
      checkResData(resData, enqueueSnackbar).then((data: any) => {
        if (data) {
          setIsOpen(false);
          afterSubmit();
        } else {
          isSubmitable.current = true;
        }
      });
    });
  };

  // キャンセル時の処理
  const cancelSubmit = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    if (isOpen) {
      isSubmitable.current = true;
    }
  }, [isOpen]);

  return {
    submit,
    cancelSubmit
  };
};
